import _ from 'lodash';

import ui from './ui';

export default _.merge(ui);
